// src/mixins/subjectAccessMixin.js
//
// Tiny read-only mixin for the product surfaces (ProductsGrid.vue,
// TeacherProducts.vue, DisplayProduct.vue).
//
// `subscriptionAccessProductIds` is populated by SubscriptionAccessAppsyncMixin
// on App.vue and contains every Product id and ProductBundle id the teacher can
// reach through a SubscriptionPackage, including the products inside accessible
// bundles. It has the same shape as `syncedBoughtProducts`, so anywhere the
// codebase asks "does this teacher own <id>?" you can ask this too.

import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      subscriptionAccessProductIds: (state) =>
        state.subscriptionAccessProductIds,
      subscriptionAccessSynced: (state) => state.subscriptionAccessSynced,
    }),

    hasAnySchoolAccess() {
      return this.subscriptionAccessProductIds?.length > 0;
    },
  },

  methods: {
    // "Owned" via a school subscription package rather than a purchase.
    hasSchoolAccess(id) {
      if (!id) return false;
      return this.subscriptionAccessProductIds?.includes(id) ? true : false;
    },
  },
};
